 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Agency Helplist
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryAgencyFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryAgencyFilterForm"
                            v-model="filtersAgency.inter"
                            :label="filtersAgencyLabel.inter"
                            :error-messages="errors.collect('filterAgency')"
                            data-vv-name="filterAgency"
                            :data-vv-as="filtersAgencyLabel.inter"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryAgencyFilterForm"
                            v-model="filtersAgency.name1"
                            :label="filtersAgencyLabel.name1"
                            :error-messages="errors.collect('filterName1')"
                            data-vv-name="filterName1"
                            :data-vv-as="filtersAgencyLabel.name1"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="headers"
          :items="agencyItems"
          v-bind:options.sync="paginationAgency"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.inter }}</td>
              <td>{{ row.item.name1 }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignAgency(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersAgencyLabel: {
        inter: 'Intermediary',
        name1: 'Name 1'
      },
      filtersAgency: {
        inter: null,
        name1: undefined
      },
      agencyItems: [],
      totalItems: 0,
      headers: [
        { text: 'Intermediary', align: 'left', value: 'inter' },
        { text: 'Name 1', align: 'left', value: 'name1' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationAgency: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    'paginationAgency': function (value) {
      this.fetchAgencyData()
    }
  },
  mounted() {
    this.doClearFilters()
  },
  methods: {
    closeDialog() {
      this.filtersAgency.inter = ''
      this.filtersAgency.name1 = ''
      this.$emit('close')
    },
    doClearFilters() {
      this.filtersAgency.inter = ''
      this.filtersAgency.name1 = ''
      this.fetchAgencyData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryAgencyFilterForm').then((result) => {
        if (result) {
          this.paginationAgency.page = 1
          this.fetchAgencyData()
        }
      })
    },
    assignAgency(data) {
      this.$emit('assign-agency', data)
      this.$emit('close')
      this.doClearFilters()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
